import { render, staticRenderFns } from "./part-icon.vue?vue&type=template&id=62b2d64f&scoped=true&"
import script from "./part-icon.vue?vue&type=script&lang=js&"
export * from "./part-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b2d64f",
  null
  
)

export default component.exports